import React, { Component } from "react";
import { connect } from "react-redux";
import { getReport, getJobPackReports } from "./actions";
import MapContainer from "../MapContainer";
import { Card, CardHeader, CardContent, Button } from "@material-ui/core";
import { selectCurrentReport } from "./selectors";
import ReactToPrint from "react-to-print";
import { cellStyle } from "../gridHelper";

class ConfinedSpace extends Component {
    constructor(props) {
        super(props);
        const path = props.location.pathname.split("/");
        if (path[2] === "reports") {
            props.getReport(
                path[2].replace(/-/g, "_"),
                path[3],
                path[5].replace(/_/g, " ").replace(/\./g, ":"),
                path[4].replace(/-/g, "_")
            );
        } else {
            props.getJobPackReports(
                props.match.params.uprn,
                path[2].replace(/-/g, "_"),
                path[3],
                path[4].replace(/-/g, "_"),
                path[5].replace(/-/g, "_"),
                props.match.params.report_id
                    .replace(/_/g, " ")
                    .replace(/\./g, ":"),
                path[7].replace(/-/g, "_")
            );
        }
        this.state = {
            reportRetrieved: false,
            report: []
        };
    }
    componentDidUpdate(prevState) {
        if (prevState.report !== this.props.report) {
            this.setState({ report: this.props.report });
        }
    }

    gridStyle = (length, width, percent) => {
        return {
            //length = repeat
            display: "grid",
            gridTemplateRow: `repeat(${length - 1}, 35px)`,
            gridTemplateColumns: `repeat(${width}, ${percent}%)`,
            //gridGap: "0.15vh",
            gridGap: "0.5mm",
            backgroundColor: "rgb(4, 71, 107)",
            border: "1px solid rgb(4, 71, 107)",
            marginBottom: "10px"
        };
    };

    cellPosition = (rowIndex, columnIndex, rowEnd, columnEnd) => {
        return {
            gridRowStart: `${rowIndex}`,
            gridRowEnd: `${rowEnd}`,
            gridColumnStart: `${columnIndex}`,
            gridColumnEnd: `${columnEnd}`
        };
    };

    cellStyle = (
        rowIndex,
        columnIndex,
        rowEnd,
        columnEnd,
        fontTrue,
        negative
    ) => {
        let font;
        let background = "white";
        let color = "black";
        if (fontTrue) {
            font = `"Handlee", cursive`;
        }
        if (negative) {
            background = "rgb(4, 71, 107)";
            color = "white";
        }
        return {
            ...this.cellPosition(rowIndex, columnIndex, rowEnd, columnEnd),
            background: `${background}`,
            fontFamily: `${font}`,
            flex: 1,
            display: "flex",
            color: `${color}`,
            padding: "10px"
        };
    };
    renderSigs(attachedSigs) {
        let sigRow = 2;
        let sigCell = 1;
        return attachedSigs.map((sig, i) => {
            let sigInfo = (
                <React.Fragment key={i}>
                    <div
                        style={cellStyle(
                            sigRow,
                            sigCell,
                            sigRow,
                            sigCell,
                            true
                        )}
                    >
                        {sig.signature_name}
                    </div>
                    <div
                        style={cellStyle(
                            sigRow,
                            sigCell + 1,
                            sigRow,
                            sigCell + 1,
                            true
                        )}
                    >
                        {sig.signature_timestamp}
                    </div>
                    <div
                        style={cellStyle(
                            sigRow + 1,
                            sigCell,
                            sigRow + 1,
                            sigCell + 2
                        )}
                    >
                        <img
                            src={sig.signature_url}
                            alt="Site "
                            onClick={() => {
                                this.setState({
                                    selectedPhoto: sig,
                                    imageModal: true
                                });
                            }}
                            style={{
                                width: 300,
                                height: 300,
                                margin: "auto",
                                cursor: "pointer"
                            }}
                        />
                    </div>
                </React.Fragment>
            );
            sigCell += 2;
            if (sigCell === 9) {
                sigRow += 2;
                sigCell = 1;
            }
            return sigInfo;
        });
    }
    renderPhotos(attachedPhotos) {
        let photoRow = 2;
        let photoCell = 1;
        return attachedPhotos.map((photo, i) => {
            let photoInfo = (
                <React.Fragment key={i}>
                    <div
                        style={cellStyle(
                            photoRow,
                            photoCell,
                            photoRow,
                            photoCell,
                            true
                        )}
                    >
                        {photo.photo_name}
                    </div>
                    <div
                        style={cellStyle(
                            photoRow,
                            photoCell + 1,
                            photoRow,
                            photoCell + 1,
                            true
                        )}
                    >
                        {photo.photo_timestamp}
                    </div>
                    <div
                        style={cellStyle(
                            photoRow + 1,
                            photoCell,
                            photoRow + 1,
                            photoCell + 2
                        )}
                    >
                        <img
                            src={photo.photo_url}
                            alt="Site "
                            onClick={() => {
                                this.setState({
                                    selectedPhoto: photo,
                                    imageModal: true
                                });
                            }}
                            style={{
                                width: 300,
                                height: 300,
                                margin: "auto",
                                cursor: "pointer"
                            }}
                        />
                    </div>
                </React.Fragment>
            );
            photoCell += 2;
            if (photoCell === 9) {
                photoRow += 2;
                photoCell = 1;
            }
            return photoInfo;
        });
    }

    render() {
        const report = this.props.report === false ? [] : this.props.report;
        const cstyle = this.cellStyle;
        const gstyle = this.gridStyle;

        return (
            <Card>
                <CardHeader title={"Confined Space Form"} />
                <CardContent>
                    <ReactToPrint
                        onBeforePrint={() => {
                            setTimeout(undefined, 2000);
                        }}
                        trigger={() => (
                            <Button
                                style={{
                                    fontSize: "30px",
                                    marginBottom: "10px"
                                }}
                                color="primary"
                                variant="contained"
                            >
                                Print
                            </Button>
                        )}
                        content={() => this.componentRef}
                    />
                    {report && (
                        <div ref={el => (this.componentRef = el)}>
                            {this.props.header && (
                                <this.props.header
                                    date={this.props.match.params.report_id}
                                    reportType={this.props.reportType}
                                />
                            )}

                            <div style={{ width: "100%" }}>
                                <div style={{ width: "60%", float: "left" }}>
                                    <div style={gstyle(5, 13)}>
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                13,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>ID</b>
                                        </div>
                                        <div style={cstyle(2, 1, 2, 13)}>
                                            <b>Name:</b>
                                        </div>
                                        <div style={cstyle(2, 6, 2, 13, true)}>
                                            {report.user_name}
                                        </div>
                                        <div style={cstyle(3, 1, 3, 13)}>
                                            <b>Email:</b>
                                        </div>
                                        <div style={cstyle(3, 6, 3, 13, true)}>
                                            {report.user_email}
                                        </div>
                                        {/* <div style={cstyle(3, 1, 3, 13)}>
                                            <b>Confined Space Form ID:</b>
                                        </div>
                                        <div style={cstyle(3, 9, 3, 13, true)}>
                                            {report.plan_id}
                                        </div> */}
                                        <div style={cstyle(4, 1, 4, 13)}>
                                            <b>Form Created: </b>
                                        </div>
                                        <div style={cstyle(4, 6, 4, 13, true)}>
                                            {report.timestamp}
                                        </div>
                                        <div style={cstyle(5, 1, 5, 13)}>
                                            <b>Client Name: </b>
                                        </div>
                                        <div style={cstyle(5, 6, 5, 13, true)}>
                                            {report.client_name}
                                        </div>
                                        <div style={cstyle(6, 1, 6, 13)}>
                                            <b>Longitude: </b>
                                        </div>
                                        <div style={cstyle(6, 6, 6, 13, true)}>
                                            {report.location_lon}
                                        </div>
                                        <div style={cstyle(7, 1, 7, 13)}>
                                            <b>Latitude: </b>
                                        </div>
                                        <div style={cstyle(7, 6, 7, 13, true)}>
                                            {report.location_lat}
                                        </div>
                                        {/* <div style={cstyle(7, 1, 7, 13)}>
                                            <b>Report URN</b>
                                        </div>
                                        <div style={cstyle(7, 7, 7, 13)}>
                                            {report.urn}
                                        </div> */}
                                    </div>
                                </div>
                                <div
                                    style={{
                                        width: "30%",
                                        float: "left",
                                        marginLeft: "2%"
                                    }}
                                >
                                    <MapContainer
                                        lat={+report.location_lat}
                                        long={+report.location_lon}
                                        style={{ width: "80%" }}
                                    />
                                </div>
                            </div>
                            <div style={{ width: "100%", clear: "both" }}>
                                <div className="break" style={gstyle(21, 4)}>
                                    <div
                                        style={cstyle(1, 1, 1, 4, false, true)}
                                    >
                                        <b>Checks</b>
                                    </div>
                                    <div style={cstyle(2, 1, 2, 4)}>
                                        <b>Brief Description of Work :</b>
                                    </div>
                                    <div style={cstyle(2, 2, 2, 4, true)}>
                                        {report.brief_desc_of_works}
                                    </div>
                                    <div style={cstyle(3, 1, 3, 4)}>
                                        <b>Confined Space Level: </b>
                                    </div>
                                    <div style={cstyle(3, 2, 3, 4, true)}>
                                        {report.cs_level}
                                    </div>
                                    {/* <div style={cstyle(4, 1, 4, 4)}>
                                        <b>Confined Space Level 2: </b>
                                    </div>
                                    <div style={cstyle(4, 2, 4, 4, true)}>
                                        {report.csform_cs_level_2}
                                    </div>
                                    <div style={cstyle(5, 1, 5, 4)}>
                                        <b>Confined Space Level 3: </b>
                                    </div>
                                    <div style={cstyle(5, 2, 5, 4, true)}>
                                        {report.csform_cs_level_3}
                                    </div> */}
                                    <div style={cstyle(4, 1, 4, 4)}>
                                        <b>Lockout/Tagout</b>
                                    </div>
                                    <div style={cstyle(4, 2, 4, 4, true)}>
                                        {report.lock_out_tag_out}
                                    </div>
                                    <div style={cstyle(5, 1, 5, 4)}>
                                        <b>
                                            Confined Space: Required - Overalls
                                            / Waterproofs
                                        </b>
                                    </div>
                                    <div style={cstyle(5, 2, 5, 4, true)}>
                                        {report.overalls_waterproofs}
                                    </div>
                                    <div style={cstyle(6, 1, 6, 4)}>
                                        <b>
                                            Confined Space: Required - Gas
                                            Monitor
                                        </b>
                                    </div>
                                    <div style={cstyle(6, 2, 6, 4, true)}>
                                        {report.gas_monitor}
                                    </div>
                                    <div style={cstyle(7, 1, 7, 4)}>
                                        <b>
                                            Confined Space: Required - Means to
                                            Call Emergency Services
                                        </b>
                                    </div>
                                    <div style={cstyle(7, 2, 7, 4, true)}>
                                        {report.means_to_call_emergency_serv}
                                    </div>
                                    <div style={cstyle(8, 1, 8, 4)}>
                                        <b>
                                            Confined Space: Required - First Aid
                                            Kit
                                        </b>
                                    </div>
                                    <div style={cstyle(8, 2, 8, 4, true)}>
                                        {report.first_aid_kit}
                                    </div>
                                    <div style={cstyle(9, 1, 9, 4)}>
                                        <b>Positive Pressure Vent</b>
                                    </div>
                                    <div style={cstyle(9, 2, 9, 4, true)}>
                                        {report.positive_pressure_vent}
                                    </div>
                                    <div style={cstyle(10, 1, 10, 4)}>
                                        <b>
                                            Confined Space: Required - Explosion
                                            Protected Light
                                        </b>
                                    </div>
                                    <div style={cstyle(10, 2, 10, 4, true)}>
                                        {report.explosion_protected_light}
                                    </div>
                                    <div style={cstyle(11, 1, 11, 4)}>
                                        <b>
                                            CConfined Space: Required - Safety
                                            Barrier/Roadsigns
                                        </b>
                                    </div>
                                    <div style={cstyle(11, 2, 11, 4, true)}>
                                        {report.safety_barrier_roadsigns}
                                    </div>
                                    <div style={cstyle(12, 1, 12, 4)}>
                                        <b>
                                            Confined Space: Required - Isolation
                                            of Valves or power sources
                                        </b>
                                    </div>
                                    <div style={cstyle(12, 2, 12, 4, true)}>
                                        {report.isolation_of_valves}
                                    </div>
                                    <div style={cstyle(13, 1, 13, 4)}>
                                        <b>
                                            Confined Space: Required - Life
                                            Jacket
                                        </b>
                                    </div>
                                    <div style={cstyle(13, 2, 13, 4, true)}>
                                        {report.life_jacket}
                                    </div>
                                    <div style={cstyle(14, 1, 14, 4)}>
                                        <b>
                                            Confined Space: Required - Bump Hat
                                        </b>
                                    </div>
                                    <div style={cstyle(14, 2, 14, 4, true)}>
                                        {report.bump_hat}
                                    </div>
                                    <div style={cstyle(15, 1, 15, 4)}>
                                        <b>
                                            Confined Space: Required - Tripod /
                                            Harness
                                        </b>
                                    </div>
                                    <div style={cstyle(15, 2, 15, 4, true)}>
                                        {report.tripod_harness}
                                    </div>
                                    <div style={cstyle(16, 1, 16, 4)}>
                                        <b>
                                            Confined Space: Required - Means of
                                            Communication
                                        </b>
                                    </div>
                                    <div style={cstyle(16, 2, 16, 4, true)}>
                                        {report.means_of_comms}
                                    </div>
                                    <div style={cstyle(17, 1, 17, 4)}>
                                        <b>
                                            Confined Space: Required - Rescue
                                            Arrangement 2 x BA Sets
                                        </b>
                                    </div>
                                    <div style={cstyle(17, 2, 17, 4, true)}>
                                        {report.rescue_arrangement}
                                    </div>
                                    <div style={cstyle(18, 1, 18, 4)}>
                                        <b>
                                            Confined Space: Required - Full BA
                                        </b>
                                    </div>
                                    <div style={cstyle(18, 2, 18, 4, true)}>
                                        {report.full_ba}
                                    </div>
                                    <div style={cstyle(19, 1, 19, 4)}>
                                        <b>
                                            Confined Space: Required - BA
                                            Trailer
                                        </b>
                                    </div>
                                    <div style={cstyle(19, 2, 19, 4, true)}>
                                        {report.ba_trailer}
                                    </div>
                                </div>
                                <div style={{ width: "100%", clear: "both" }}>
                                    <div style={gstyle(3, 4)}>
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                4,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Topman & Additional Comments</b>
                                        </div>
                                        <div style={cstyle(2, 1, 2, 4)}>
                                            <b>Topman:</b>
                                        </div>
                                        <div style={cstyle(2, 2, 2, 4, true)}>
                                            {report.top_man}
                                        </div>
                                        <div style={cstyle(3, 1, 3, 4)}>
                                            <b>Additional Comments:</b>
                                        </div>
                                        <div style={cstyle(3, 2, 3, 4, true)}>
                                            {report.additional_comments}
                                        </div>
                                    </div>
                                </div>
                                <div style={{ width: "100%", clear: "both" }}>
                                    <div style={gstyle(3, 4)}>
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                4,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>
                                                Gas Monitor Self Calibration
                                                Check
                                            </b>
                                        </div>
                                        <div style={cstyle(2, 1, 2, 4)}>
                                            <b>Serial Number of Monitor:</b>
                                        </div>
                                        <div style={cstyle(2, 2, 2, 4, true)}>
                                            {report.gas_monitor_serial_no}
                                        </div>
                                        <div style={cstyle(3, 1, 3, 4)}>
                                            <b>Number of Days Left</b>
                                        </div>
                                        <div style={cstyle(3, 2, 3, 4, true)}>
                                            {report.gas_monitor_days_remaining}
                                        </div>
                                    </div>
                                </div>
                                <div style={{ width: "100%", clear: "both" }}>
                                    <div style={gstyle(6, 10, 9.9)}>
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                8,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>
                                                Persons Entering Confined Space
                                            </b>
                                        </div>
                                        <div
                                            style={cstyle(
                                                2,
                                                1,
                                                2,
                                                1,
                                                false,
                                                true
                                            )}
                                        />
                                        <div
                                            style={cstyle(
                                                2,
                                                2,
                                                2,
                                                5,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Name:</b>
                                        </div>
                                        <div
                                            style={cstyle(
                                                2,
                                                5,
                                                2,
                                                8,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Time In:</b>
                                        </div>
                                        <div
                                            style={cstyle(
                                                2,
                                                8,
                                                3,
                                                10,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Time Out:</b>
                                        </div>
                                        <div
                                            style={cstyle(
                                                3,
                                                1,
                                                3,
                                                2,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Person 1:</b>
                                        </div>
                                        <div style={cstyle(3, 2, 3, 5, true)}>
                                            {report.entering_cs_name_1}
                                        </div>
                                        <div style={cstyle(3, 5, 3, 8, true)}>
                                            {report.entering_cs_time_in_1}
                                        </div>
                                        <div style={cstyle(3, 8, 3, 11, true)}>
                                            {report.entering_cs_time_out_1}
                                        </div>
                                        <div
                                            style={cstyle(
                                                4,
                                                1,
                                                4,
                                                2,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Person 2:</b>
                                        </div>
                                        <div style={cstyle(4, 2, 4, 5, true)}>
                                            {report.entering_cs_name_2}
                                        </div>
                                        <div style={cstyle(4, 5, 4, 8, true)}>
                                            {report.entering_cs_time_in_2}
                                        </div>
                                        <div style={cstyle(4, 8, 4, 11, true)}>
                                            {report.entering_cs_time_out_2}
                                        </div>
                                        <div
                                            style={cstyle(
                                                5,
                                                1,
                                                5,
                                                2,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Person 3:</b>
                                        </div>
                                        <div style={cstyle(5, 2, 5, 5, true)}>
                                            {report.entering_cs_name_3}
                                        </div>
                                        <div style={cstyle(5, 5, 5, 8, true)}>
                                            {report.entering_cs_time_in_3}
                                        </div>
                                        <div style={cstyle(5, 8, 5, 11, true)}>
                                            {report.entering_cs_time_out_3}
                                        </div>
                                        <div
                                            style={cstyle(
                                                6,
                                                1,
                                                6,
                                                2,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Person 4:</b>
                                        </div>
                                        <div style={cstyle(6, 2, 6, 5, true)}>
                                            {report.entering_cs_name_4}
                                        </div>
                                        <div style={cstyle(6, 5, 6, 8, true)}>
                                            {report.entering_cs_time_in_4}
                                        </div>
                                        <div style={cstyle(6, 8, 6, 11, true)}>
                                            {report.entering_cs_time_out_4}
                                        </div>
                                        <div
                                            style={cstyle(
                                                7,
                                                1,
                                                7,
                                                2,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Person 5:</b>
                                        </div>
                                        <div style={cstyle(7, 2, 7, 5, true)}>
                                            {report.entering_cs_name_5}
                                        </div>
                                        <div style={cstyle(7, 5, 7, 8, true)}>
                                            {report.entering_cs_time_in_5}
                                        </div>
                                        <div style={cstyle(7, 8, 7, 11, true)}>
                                            {report.entering_cs_time_out_5}
                                        </div>
                                        <div
                                            style={cstyle(
                                                8,
                                                1,
                                                8,
                                                2,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Person 6:</b>
                                        </div>
                                        <div style={cstyle(8, 2, 8, 5, true)}>
                                            {report.entering_cs_name_6}
                                        </div>
                                        <div style={cstyle(8, 5, 8, 8, true)}>
                                            {report.entering_cs_time_in_6}
                                        </div>
                                        <div style={cstyle(8, 8, 8, 11, true)}>
                                            {report.entering_cs_time_out_6}
                                        </div>
                                        <div
                                            style={cstyle(
                                                9,
                                                1,
                                                9,
                                                2,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Person 7:</b>
                                        </div>
                                        <div style={cstyle(9, 2, 9, 5, true)}>
                                            {report.entering_cs_name_7}
                                        </div>
                                        <div style={cstyle(9, 5, 9, 8, true)}>
                                            {report.entering_cs_time_in_7}
                                        </div>
                                        <div style={cstyle(9, 8, 9, 11, true)}>
                                            {report.entering_cs_time_out_7}
                                        </div>
                                        <div
                                            style={cstyle(
                                                10,
                                                1,
                                                10,
                                                2,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Person 8:</b>
                                        </div>
                                        <div style={cstyle(10, 2, 10, 5, true)}>
                                            {report.entering_cs_name_8}
                                        </div>
                                        <div style={cstyle(10, 5, 10, 8, true)}>
                                            {report.entering_cs_time_in_8}
                                        </div>
                                        <div
                                            style={cstyle(10, 8, 10, 11, true)}
                                        >
                                            {report.entering_cs_time_out_8}
                                        </div>
                                        <div
                                            style={cstyle(
                                                11,
                                                1,
                                                11,
                                                2,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Person 9:</b>
                                        </div>
                                        <div style={cstyle(11, 2, 11, 5, true)}>
                                            {report.entering_cs_name_9}
                                        </div>
                                        <div style={cstyle(11, 5, 11, 8, true)}>
                                            {report.entering_cs_time_in_9}
                                        </div>
                                        <div
                                            style={cstyle(11, 8, 11, 11, true)}
                                        >
                                            {report.entering_cs_time_out_9}
                                        </div>
                                        <div
                                            style={cstyle(
                                                12,
                                                1,
                                                12,
                                                2,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Person 10:</b>
                                        </div>
                                        <div style={cstyle(12, 2, 12, 5, true)}>
                                            {report.entering_cs_name_10}
                                        </div>
                                        <div style={cstyle(12, 5, 12, 8, true)}>
                                            {report.entering_cs_time_in_10}
                                        </div>
                                        <div
                                            style={cstyle(12, 8, 12, 11, true)}
                                        >
                                            {report.entering_cs_time_out_10}
                                        </div>
                                    </div>
                                    <div
                                        style={{ width: "100%", clear: "both" }}
                                    >
                                        <div
                                            className="break"
                                            style={gstyle(14, 12, 9)}
                                        >
                                            <div
                                                style={cstyle(
                                                    1,
                                                    1,
                                                    1,
                                                    12,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>Gas Monitor Readings</b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    2,
                                                    1,
                                                    2,
                                                    1,
                                                    false,
                                                    true
                                                )}
                                            />
                                            <div
                                                style={cstyle(
                                                    2,
                                                    2,
                                                    2,
                                                    4,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>Time</b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    2,
                                                    4,
                                                    2,
                                                    6,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>O2</b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    2,
                                                    6,
                                                    2,
                                                    8,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>LEL</b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    2,
                                                    8,
                                                    2,
                                                    10,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>CO</b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    2,
                                                    10,
                                                    2,
                                                    12,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>H2S</b>
                                            </div>

                                            <div
                                                style={cstyle(
                                                    3,
                                                    1,
                                                    3,
                                                    1,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>Fresh Air Test</b>
                                            </div>
                                            <div
                                                style={cstyle(3, 2, 3, 4, true)}
                                            >
                                                {report.gmr_time_1}
                                            </div>
                                            <div
                                                style={cstyle(3, 4, 3, 6, true)}
                                            >
                                                {report.gmr_o2_1}
                                            </div>
                                            <div
                                                style={cstyle(3, 6, 3, 8, true)}
                                            >
                                                {report.gmr_lel_1}
                                            </div>
                                            <div
                                                style={cstyle(
                                                    3,
                                                    8,
                                                    3,
                                                    10,
                                                    true
                                                )}
                                            >
                                                {report.gmr_co_1}
                                            </div>
                                            <div
                                                style={cstyle(
                                                    3,
                                                    10,
                                                    3,
                                                    12,
                                                    true
                                                )}
                                            >
                                                {report.gmr_h2s_1}
                                            </div>
                                            <div
                                                style={cstyle(
                                                    4,
                                                    1,
                                                    4,
                                                    1,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>Pre-Entry Test</b>
                                            </div>
                                            <div
                                                style={cstyle(4, 2, 4, 4, true)}
                                            >
                                                {report.gmr_time_2}
                                            </div>
                                            <div
                                                style={cstyle(4, 4, 4, 6, true)}
                                            >
                                                {report.gmr_o2_2}
                                            </div>
                                            <div
                                                style={cstyle(4, 6, 4, 8, true)}
                                            >
                                                {report.gmr_lel_2}
                                            </div>
                                            <div
                                                style={cstyle(
                                                    4,
                                                    8,
                                                    4,
                                                    10,
                                                    true
                                                )}
                                            >
                                                {report.gmr_co_2}
                                            </div>
                                            <div
                                                style={cstyle(
                                                    4,
                                                    10,
                                                    4,
                                                    12,
                                                    true
                                                )}
                                            >
                                                {report.gmr_h2s_2}
                                            </div>
                                            <div
                                                style={cstyle(
                                                    5,
                                                    1,
                                                    5,
                                                    1,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>Time 1:</b>
                                            </div>
                                            <div
                                                style={cstyle(5, 2, 5, 4, true)}
                                            >
                                                {report.gmr_time_3}
                                            </div>
                                            <div
                                                style={cstyle(5, 4, 5, 6, true)}
                                            >
                                                {report.gmr_o2_3}
                                            </div>
                                            <div
                                                style={cstyle(5, 6, 5, 8, true)}
                                            >
                                                {report.gmr_lel_3}
                                            </div>
                                            <div
                                                style={cstyle(
                                                    5,
                                                    8,
                                                    5,
                                                    10,
                                                    true
                                                )}
                                            >
                                                {report.gmr_co_3}
                                            </div>
                                            <div
                                                style={cstyle(
                                                    5,
                                                    10,
                                                    5,
                                                    12,
                                                    true
                                                )}
                                            >
                                                {report.gmr_h2s_3}
                                            </div>
                                            <div
                                                style={cstyle(
                                                    6,
                                                    1,
                                                    6,
                                                    1,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>Time 2:</b>
                                            </div>
                                            <div
                                                style={cstyle(6, 2, 6, 4, true)}
                                            >
                                                {report.gmr_time_4}
                                            </div>
                                            <div
                                                style={cstyle(6, 4, 6, 6, true)}
                                            >
                                                {report.gmr_o2_4}
                                            </div>
                                            <div
                                                style={cstyle(6, 6, 6, 8, true)}
                                            >
                                                {report.gmr_lel_4}
                                            </div>
                                            <div
                                                style={cstyle(
                                                    6,
                                                    8,
                                                    6,
                                                    10,
                                                    true
                                                )}
                                            >
                                                {report.gmr_co_4}
                                            </div>
                                            <div
                                                style={cstyle(
                                                    6,
                                                    10,
                                                    6,
                                                    12,
                                                    true
                                                )}
                                            >
                                                {report.gmr_h2s_4}
                                            </div>
                                            <div
                                                style={cstyle(
                                                    7,
                                                    1,
                                                    7,
                                                    1,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>Time 3:</b>
                                            </div>
                                            <div
                                                style={cstyle(7, 2, 7, 4, true)}
                                            >
                                                {report.gmr_time_5}
                                            </div>
                                            <div
                                                style={cstyle(7, 4, 7, 6, true)}
                                            >
                                                {report.gmr_o2_5}
                                            </div>
                                            <div
                                                style={cstyle(7, 6, 7, 8, true)}
                                            >
                                                {report.gmr_lel_5}
                                            </div>
                                            <div
                                                style={cstyle(
                                                    7,
                                                    8,
                                                    7,
                                                    10,
                                                    true
                                                )}
                                            >
                                                {report.gmr_co_5}
                                            </div>
                                            <div
                                                style={cstyle(
                                                    7,
                                                    10,
                                                    7,
                                                    12,
                                                    true
                                                )}
                                            >
                                                {report.gmr_h2s_5}
                                            </div>
                                            <div
                                                style={cstyle(
                                                    8,
                                                    1,
                                                    8,
                                                    1,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>Time 4:</b>
                                            </div>
                                            <div
                                                style={cstyle(8, 2, 8, 4, true)}
                                            >
                                                {report.gmr_time_6}
                                            </div>
                                            <div
                                                style={cstyle(8, 4, 8, 6, true)}
                                            >
                                                {report.gmr_o2_6}
                                            </div>
                                            <div
                                                style={cstyle(8, 6, 8, 8, true)}
                                            >
                                                {report.gmr_lel_6}
                                            </div>
                                            <div
                                                style={cstyle(
                                                    8,
                                                    8,
                                                    8,
                                                    10,
                                                    true
                                                )}
                                            >
                                                {report.gmr_co_6}
                                            </div>
                                            <div
                                                style={cstyle(
                                                    8,
                                                    10,
                                                    8,
                                                    12,
                                                    true
                                                )}
                                            >
                                                {report.gmr_h2s_6}
                                            </div>
                                            <div
                                                style={cstyle(
                                                    9,
                                                    1,
                                                    9,
                                                    1,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>Time 5:</b>
                                            </div>
                                            <div
                                                style={cstyle(9, 2, 9, 4, true)}
                                            >
                                                {report.gmr_time_7}
                                            </div>
                                            <div
                                                style={cstyle(9, 4, 9, 6, true)}
                                            >
                                                {report.gmr_o2_7}
                                            </div>
                                            <div
                                                style={cstyle(9, 6, 9, 8, true)}
                                            >
                                                {report.gmr_lel_7}
                                            </div>
                                            <div
                                                style={cstyle(
                                                    9,
                                                    8,
                                                    9,
                                                    10,
                                                    true
                                                )}
                                            >
                                                {report.gmr_co_7}
                                            </div>
                                            <div
                                                style={cstyle(
                                                    9,
                                                    10,
                                                    9,
                                                    12,
                                                    true
                                                )}
                                            >
                                                {report.gmr_h2s_7}
                                            </div>
                                            <div
                                                style={cstyle(
                                                    10,
                                                    1,
                                                    10,
                                                    1,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>Time 6:</b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    10,
                                                    2,
                                                    10,
                                                    4,
                                                    true
                                                )}
                                            >
                                                {report.gmr_time_8}
                                            </div>
                                            <div
                                                style={cstyle(
                                                    10,
                                                    4,
                                                    10,
                                                    6,
                                                    true
                                                )}
                                            >
                                                {report.gmr_o2_8}
                                            </div>
                                            <div
                                                style={cstyle(
                                                    10,
                                                    6,
                                                    10,
                                                    8,
                                                    true
                                                )}
                                            >
                                                {report.gmr_lel_8}
                                            </div>
                                            <div
                                                style={cstyle(
                                                    10,
                                                    8,
                                                    10,
                                                    10,
                                                    true
                                                )}
                                            >
                                                {report.gmr_co_8}
                                            </div>
                                            <div
                                                style={cstyle(
                                                    10,
                                                    10,
                                                    10,
                                                    12,
                                                    true
                                                )}
                                            >
                                                {report.gmr_h2s_8}
                                            </div>
                                            <div
                                                style={cstyle(
                                                    11,
                                                    1,
                                                    11,
                                                    1,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>Time 7:</b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    11,
                                                    2,
                                                    11,
                                                    4,
                                                    true
                                                )}
                                            >
                                                {report.gmr_time_9}
                                            </div>
                                            <div
                                                style={cstyle(
                                                    11,
                                                    4,
                                                    11,
                                                    6,
                                                    true
                                                )}
                                            >
                                                {report.gmr_o2_9}
                                            </div>
                                            <div
                                                style={cstyle(
                                                    11,
                                                    6,
                                                    11,
                                                    8,
                                                    true
                                                )}
                                            >
                                                {report.gmr_lel_9}
                                            </div>
                                            <div
                                                style={cstyle(
                                                    11,
                                                    8,
                                                    11,
                                                    10,
                                                    true
                                                )}
                                            >
                                                {report.gmr_co_9}
                                            </div>
                                            <div
                                                style={cstyle(
                                                    11,
                                                    10,
                                                    11,
                                                    12,
                                                    true
                                                )}
                                            >
                                                {report.gmr_h2s_9}
                                            </div>
                                            <div
                                                style={cstyle(
                                                    12,
                                                    1,
                                                    12,
                                                    1,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>Time 8:</b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    12,
                                                    2,
                                                    12,
                                                    4,
                                                    true
                                                )}
                                            >
                                                {report.gmr_time_10}
                                            </div>
                                            <div
                                                style={cstyle(
                                                    12,
                                                    4,
                                                    12,
                                                    6,
                                                    true
                                                )}
                                            >
                                                {report.gmr_o2_10}
                                            </div>
                                            <div
                                                style={cstyle(
                                                    12,
                                                    6,
                                                    12,
                                                    8,
                                                    true
                                                )}
                                            >
                                                {report.gmr_lel_10}
                                            </div>
                                            <div
                                                style={cstyle(
                                                    12,
                                                    8,
                                                    12,
                                                    10,
                                                    true
                                                )}
                                            >
                                                {report.gmr_co_10}
                                            </div>
                                            <div
                                                style={cstyle(
                                                    12,
                                                    10,
                                                    12,
                                                    12,
                                                    true
                                                )}
                                            >
                                                {report.gmr_h2s_10}
                                            </div>
                                            {/* <div
                                                style={cstyle(
                                                    13,
                                                    1,
                                                    13,
                                                    3,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>Fresh Air Test:</b>
                                            </div> */}
                                            {/* <div
                                                style={cstyle(
                                                    13,
                                                    3,
                                                    13,
                                                    6,
                                                    true
                                                )}
                                            >
                                                {report.fresh_air_test}
                                            </div> */}
                                            {/* <div
                                                style={cstyle(
                                                    13,
                                                    6,
                                                    13,
                                                    9,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>Fresh Air Time:</b>
                                            </div> */}
                                            {/* <div
                                                style={cstyle(
                                                    13,
                                                    9,
                                                    13,
                                                    12,
                                                    true
                                                )}
                                            >
                                                {report.fresh_air_time}
                                            </div> */}
                                            {/* <div
                                                style={cstyle(
                                                    14,
                                                    1,
                                                    14,
                                                    3,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>Pre-Entry Test:</b>
                                            </div> */}
                                            {/* <div
                                                style={cstyle(
                                                    14,
                                                    3,
                                                    14,
                                                    6,
                                                    true
                                                )}
                                            >
                                                {report.pre_entry_test}
                                            </div> */}
                                            {/* <div
                                                style={cstyle(
                                                    14,
                                                    6,
                                                    14,
                                                    9,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>Pre-Entry Time:</b>
                                            </div> */}
                                            {/* <div
                                                style={cstyle(
                                                    14,
                                                    9,
                                                    14,
                                                    12,
                                                    true
                                                )}
                                            >
                                                {report.pre_entry_time}
                                            </div> */}
                                        </div>
                                    </div>
                                    <div
                                        style={{ width: "100%", clear: "both" }}
                                    >
                                        <div style={gstyle(10, 10, 9.9)}>
                                            <div
                                                style={cstyle(
                                                    1,
                                                    1,
                                                    1,
                                                    8,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>
                                                    Equipment In Confined Space
                                                </b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    2,
                                                    1,
                                                    2,
                                                    1,
                                                    false,
                                                    true
                                                )}
                                            />
                                            <div
                                                style={cstyle(
                                                    2,
                                                    2,
                                                    2,
                                                    5,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>Equipment</b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    2,
                                                    5,
                                                    2,
                                                    8,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>Checked In:</b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    2,
                                                    8,
                                                    3,
                                                    10,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>Checked Out Out:</b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    3,
                                                    1,
                                                    3,
                                                    2,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>1:</b>
                                            </div>
                                            <div
                                                style={cstyle(3, 2, 3, 5, true)}
                                            >
                                                {report.equip_in_cs_name_1}
                                            </div>
                                            <div
                                                style={cstyle(3, 5, 3, 8, true)}
                                            >
                                                {
                                                    report.equip_in_cs_checked_in_1
                                                }
                                            </div>
                                            <div
                                                style={cstyle(
                                                    3,
                                                    8,
                                                    3,
                                                    11,
                                                    true
                                                )}
                                            >
                                                {
                                                    report.equip_in_cs_checked_out_1
                                                }
                                            </div>
                                            <div
                                                style={cstyle(
                                                    4,
                                                    1,
                                                    4,
                                                    2,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>2:</b>
                                            </div>
                                            <div
                                                style={cstyle(4, 2, 4, 5, true)}
                                            >
                                                {report.equip_in_cs_name_2}
                                            </div>
                                            <div
                                                style={cstyle(4, 5, 4, 8, true)}
                                            >
                                                {
                                                    report.equip_in_cs_checked_in_2
                                                }
                                            </div>
                                            <div
                                                style={cstyle(
                                                    4,
                                                    8,
                                                    4,
                                                    11,
                                                    true
                                                )}
                                            >
                                                {
                                                    report.equip_in_cs_checked_out_2
                                                }
                                            </div>
                                            <div
                                                style={cstyle(
                                                    5,
                                                    1,
                                                    5,
                                                    2,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>3:</b>
                                            </div>
                                            <div
                                                style={cstyle(5, 2, 5, 5, true)}
                                            >
                                                {report.equip_in_cs_name_3}
                                            </div>
                                            <div
                                                style={cstyle(5, 5, 5, 8, true)}
                                            >
                                                {
                                                    report.equip_in_cs_checked_in_3
                                                }
                                            </div>
                                            <div
                                                style={cstyle(
                                                    5,
                                                    8,
                                                    5,
                                                    11,
                                                    true
                                                )}
                                            >
                                                {
                                                    report.equip_in_cs_checked_out_3
                                                }
                                            </div>
                                            <div
                                                style={cstyle(
                                                    6,
                                                    1,
                                                    6,
                                                    2,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>4:</b>
                                            </div>
                                            <div
                                                style={cstyle(6, 2, 6, 5, true)}
                                            >
                                                {report.equip_in_cs_name_4}
                                            </div>
                                            <div
                                                style={cstyle(6, 5, 6, 8, true)}
                                            >
                                                {
                                                    report.equip_in_cs_checked_in_4
                                                }
                                            </div>
                                            <div
                                                style={cstyle(
                                                    6,
                                                    8,
                                                    6,
                                                    11,
                                                    true
                                                )}
                                            >
                                                {
                                                    report.equip_in_cs_checked_out_4
                                                }
                                            </div>
                                            <div
                                                style={cstyle(
                                                    7,
                                                    1,
                                                    7,
                                                    2,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>5:</b>
                                            </div>
                                            <div
                                                style={cstyle(7, 2, 7, 5, true)}
                                            >
                                                {report.equip_in_cs_name_5}
                                            </div>
                                            <div
                                                style={cstyle(7, 5, 7, 8, true)}
                                            >
                                                {
                                                    report.equip_in_cs_checked_in_5
                                                }
                                            </div>
                                            <div
                                                style={cstyle(
                                                    7,
                                                    8,
                                                    7,
                                                    11,
                                                    true
                                                )}
                                            >
                                                {
                                                    report.equip_in_cs_checked_out_5
                                                }
                                            </div>
                                            <div
                                                style={cstyle(
                                                    8,
                                                    1,
                                                    8,
                                                    2,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>6:</b>
                                            </div>
                                            <div
                                                style={cstyle(8, 2, 8, 5, true)}
                                            >
                                                {report.equip_in_cs_name_6}
                                            </div>
                                            <div
                                                style={cstyle(8, 5, 8, 8, true)}
                                            >
                                                {
                                                    report.equip_in_cs_checked_in_6
                                                }
                                            </div>
                                            <div
                                                style={cstyle(
                                                    8,
                                                    8,
                                                    8,
                                                    11,
                                                    true
                                                )}
                                            >
                                                {
                                                    report.equip_in_cs_checked_out_6
                                                }
                                            </div>
                                            <div
                                                style={cstyle(
                                                    9,
                                                    1,
                                                    9,
                                                    2,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>7:</b>
                                            </div>
                                            <div
                                                style={cstyle(9, 2, 9, 5, true)}
                                            >
                                                {report.equip_in_cs_name_7}
                                            </div>
                                            <div
                                                style={cstyle(9, 5, 9, 8, true)}
                                            >
                                                {
                                                    report.equip_in_cs_checked_in_7
                                                }
                                            </div>
                                            <div
                                                style={cstyle(
                                                    9,
                                                    8,
                                                    9,
                                                    11,
                                                    true
                                                )}
                                            >
                                                {
                                                    report.equip_in_cs_checked_out_7
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div
                                        style={{ width: "100%", clear: "both" }}
                                    >
                                        <div
                                            style={{
                                                width: "45%",
                                                float: "left"
                                            }}
                                        >
                                            <div style={gstyle(7, 7)}>
                                                <div
                                                    style={cstyle(
                                                        1,
                                                        1,
                                                        1,
                                                        7,
                                                        false,
                                                        true
                                                    )}
                                                >
                                                    <b>
                                                        Signatures (User &
                                                        Visitor)
                                                    </b>
                                                </div>

                                                <div style={cstyle(2, 1, 4, 3)}>
                                                    <img
                                                        style={{
                                                            width: "200px",
                                                            height: "200px",
                                                            margin: "auto"
                                                        }}
                                                        src={
                                                            report.cssignatureurl ===
                                                                undefined ||
                                                            report.cssignatureurl ===
                                                                null ||
                                                            report.cssignatureurl ===
                                                                ""
                                                                ? noSig
                                                                : report.cssignatureurl
                                                        }
                                                        alt="No Signature Available"
                                                    />
                                                </div>

                                                <div style={cstyle(2, 3, 4, 7)}>
                                                    <img
                                                        style={{
                                                            width: "200px",
                                                            height: "200px",
                                                            margin: "auto"
                                                        }}
                                                        src={
                                                            report.cssignatureurl_2 ===
                                                                undefined ||
                                                            report.cssignatureurl_2 ===
                                                                null ||
                                                            report.cssignatureurl_2 ===
                                                                ""
                                                                ? noSig
                                                                : report.cssignatureurl_2
                                                        }
                                                        alt="No Signature Available"
                                                    />
                                                </div>
                                                <div style={cstyle(5, 1, 5, 7)}>
                                                    <b>Entrants Name:</b>
                                                </div>
                                                <div
                                                    style={cstyle(
                                                        5,
                                                        4,
                                                        5,
                                                        7,
                                                        true
                                                    )}
                                                >
                                                    {report.user_name}
                                                </div>
                                                <div style={cstyle(6, 1, 6, 7)}>
                                                    <b>Visitor Name:</b>
                                                </div>
                                                <div
                                                    style={cstyle(
                                                        6,
                                                        4,
                                                        6,
                                                        7,
                                                        true
                                                    )}
                                                >
                                                    {report.visitor_name_text}
                                                </div>
                                                <div style={cstyle(7, 1, 7, 7)}>
                                                    <b>Entrants Timestamp:</b>
                                                </div>
                                                <div
                                                    style={cstyle(
                                                        7,
                                                        4,
                                                        7,
                                                        7,
                                                        true
                                                    )}
                                                >
                                                    {
                                                        report.inspection_sig_timestamp
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            style={{
                                                width: "45%",
                                                float: "right"
                                            }}
                                        >
                                            <div style={gstyle(7, 1)}>
                                                <div
                                                    style={cstyle(
                                                        1,
                                                        1,
                                                        1,
                                                        1,
                                                        false,
                                                        true
                                                    )}
                                                >
                                                    <b>Image From Site</b>
                                                </div>
                                                <div style={cstyle(2, 1, 6, 1)}>
                                                    <img
                                                        style={{
                                                            width: "200px",
                                                            height: "200px",
                                                            margin: "auto"
                                                        }}
                                                        src={
                                                            report.image_1 ===
                                                                undefined ||
                                                            report.image_1 ===
                                                                null ||
                                                            report.image_1 ===
                                                                ""
                                                                ? noImg
                                                                : report.image_1
                                                        }
                                                        alt="Site"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                    <div style={gstyle(4, 9, null)}>
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                1,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Attached Photos</b>
                                        </div>
                                        {report.attached_photos &&
                                            this.renderPhotos(
                                                report.attached_photos
                                            )}
                                    </div>
                                    <div style={gstyle(4, 9, null)}>
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                1,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Attached Signatures</b>
                                        </div>
                                        {report.attached_signatures &&
                                            this.renderSigs(
                                                report.attached_signatures
                                            )}
                                    </div>
                                </div>
                            </div>
                            {/* <div
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    flexDirection: "row-reverse"
                                }}
                            >
                                <ProWorkFooter.view />
                            </div> */}
                        </div>
                    )}
                </CardContent>
            </Card>
        );
    }
}

export default connect(
    store => {
        return {
            report: selectCurrentReport(store)
        };
    },
    { getReport, getJobPackReports }
)(ConfinedSpace);
